import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PUP_WT: TStep[] = [
  {
    pageId: PageId.DOG_AGE_PUP_WT,
  },
  {
    pageId: PageId.DOG_OWNER_PUP_WT,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_PUP_WT,
  },
  {
    pageId: PageId.URGE_PAGE_PUP_WT,
  },
  {
    pageId: PageId.DOG_BREED_PUP_WT,
  },
  {
    pageId: PageId.FACING_CHALLENGES_PUP_WT,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_PUP_WT,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_PUP_WT,
  },
  {
    pageId: PageId.URGE_PROGRAM_PUP_WT,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_PUP_WT,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_PUP_WT,
  },
  {
    pageId: PageId.URGE_PAGE_4_PUP_WT,
  },
  {
    pageId: PageId.COMMANDS_PUP_WT,
  },
  {
    pageId: PageId.PARENT_GOAL_PUP_WT,
  },
  {
    pageId: PageId.TRAINING_PLACE_PUP_WT,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_PUP_WT,
  },
  {
    pageId: PageId.URGE_PAGE_5_PUP_WT,
  },
  {
    pageId: PageId.PREPARE_FLOW_PUP_WT,
  },
  {
    pageId: PageId.EMAIL_PUP_WT,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PUP_WT,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_PUP_WT,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PUP_WT,
  },
  {
    pageId: PageId.CHAT_UPSELL_PUP_WT,
  },
  {
    pageId: PageId.UPSELL_PUP_WT,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PUP_WT,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_WT,
  },
  {
    pageId: PageId.DOWNLOAD_PUP_WT,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_WT.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_WT.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_WT,
  PageId.FACING_CHALLENGES_2_PUP_WT,
  PageId.DOG_BREED_PUP_WT,
  PageId.BEHAVIOR_FEELINGS_PUP_WT,
  PageId.FIX_BEHAVIOR_PUP_WT,
  PageId.PARENT_GOAL_PUP_WT,
  PageId.TRAINING_PLACE_PUP_WT,
  PageId.TRAINING_FREQUENCY_PUP_WT,
]

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_WT,
  PageId.FACING_CHALLENGES_2_PUP_WT,
  PageId.DOG_BREED_PUP_WT,
  PageId.BEHAVIOR_FEELINGS_PUP_WT,
  PageId.FIX_BEHAVIOR_PUP_WT,
  PageId.PARENT_GOAL_PUP_WT,
  PageId.TRAINING_PLACE_PUP_WT,
  PageId.TRAINING_FREQUENCY_PUP_WT,
]
